// 体育相关类型声明
import cheerMp3 from 'web_v2/public/assets/mp3/cheer.mp3';
import whistleMp3 from 'web_v2/public/assets/mp3/whistle.mp3';
import doorBellMp3 from 'web_v2/public/assets/mp3/doorBell.mp3';
import praiseMp3 from 'web_v2/public/assets/mp3/praise.mp3';
import showOffMp3 from 'web_v2/public/assets/mp3/showOff.mp3';
import brisk1Mp3 from 'web_v2/public/assets/mp3/brisk1.mp3';
import brisk2Mp3 from 'web_v2/public/assets/mp3/brisk2.mp3';
import brisk3Mp3 from 'web_v2/public/assets/mp3/brisk3.mp3';
import rising1Mp3 from 'web_v2/public/assets/mp3/rising1.mp3';
import rising2Mp3 from 'web_v2/public/assets/mp3/rising2.mp3';
import rising3Mp3 from 'web_v2/public/assets/mp3/rising3.mp3';
import soft1Mp3 from 'web_v2/public/assets/mp3/soft1.mp3';
import soft2Mp3 from 'web_v2/public/assets/mp3/soft2.mp3';
import soft3Mp3 from 'web_v2/public/assets/mp3/soft3.mp3';

export interface WsSportType {}

// 国际版 or 亚洲版
export enum WsSportLayout {
    International = 'International', // 国际版
    Asia = 'Asia', // 亚洲版
}

// 盘口设置
export enum WsSportHandicap {
    Europe = 'Europe', // 欧洲盘
    HongKong = 'HongKong', // 香港盘
    // Malaysia = 'Malaysia', // 马来盘
    // Indonesia = 'Indonesia', // 印尼盘
}

// 赔率设置 自动接收更好赔率 or 自动接收任何赔率变动 or 永远不会接收赔率变动
export enum WsSportOdds {
    Better = 2, // 自动接收更好赔率
    Any = 1, // 自动接收任何赔率变动
    Never = 0, // 永远不会接收赔率变动
}

// 足球进球推送 我的收藏赛事 or 我的投注赛事 or 全部足球赛事
export enum WsSportGoal {
    Collect = '1', // 我的收藏赛事
    Bet = '2', // 我的投注赛事
    All = '3', // 全部足球赛事
}

// 推送声音提示
/**
 * 欢呼声-cheer
 * 哨声-whistle
 * 门铃声-doorBell
 * 赞叹声-praise
 * 炫耀声-showOff
 * 轻快声1-brisk1
 * 轻快声2-brisk2
 * 轻快声3-brisk3
 * 上升音1-rising1
 * 上升音2-rising2
 * 上升音3-rising3
 * 怀柔声1-soft1
 * 怀柔声2-soft2
 * 怀柔声3-soft3
 */
export interface WsSportSoundType {
    label: string;
    value: number;
    mp3: HTMLAudioElement;
}

export const WsSportSound = [
    {
        label: '欢呼声',
        value: 1,
        mp3: new Audio(cheerMp3),
    },
    {
        label: '哨声',
        value: 2,
        mp3: new Audio(whistleMp3),
    },
    {
        label: '门铃声',
        value: 3,
        mp3: new Audio(doorBellMp3),
    },
    {
        label: '赞叹声',
        value: 4,
        mp3: new Audio(praiseMp3),
    },
    {
        label: '炫耀声',
        value: 5,
        mp3: new Audio(showOffMp3),
    },
    {
        label: '轻快声1',
        value: 6,
        mp3: new Audio(brisk1Mp3),
    },
    {
        label: '轻快声2',
        value: 7,
        mp3: new Audio(brisk2Mp3),
    },
    {
        label: '轻快声3',
        value: 8,
        mp3: new Audio(brisk3Mp3),
    },
    {
        label: '上升音1',
        value: 9,
        mp3: new Audio(rising1Mp3),
    },
    {
        label: '上升音2',
        value: 10,
        mp3: new Audio(rising2Mp3),
    },
    {
        label: '上升音3',
        value: 11,
        mp3: new Audio(rising3Mp3),
    },
    {
        label: '怀柔声1',
        value: 12,
        mp3: new Audio(soft1Mp3),
    },
    {
        label: '怀柔声2',
        value: 13,
        mp3: new Audio(soft2Mp3),
    },
    {
        label: '怀柔声3',
        value: 14,
        mp3: new Audio(soft3Mp3),
    },
];

// 游戏类型
export interface OfficialSportTypeEnumType {
    code?: number;
    name?: string;
    sort?: number;
}

// 国家列表
export interface countryListType {
    name: string;
    id: string;
    icon?: string;
    show?: boolean;
    list: leagueListType[];
}

// 赛果列表
export interface leagueListType {
    name: string;
    count: string;
    id: string;
    list?: recordsListType[];
    show?: boolean;
}

export interface recordsListType {
    id: string;
    league: string;
    leagueId: number;
    gid: string;
    matchStartTime: Date;
    type: number;
    typeLabel: string;
    normalScore: NormalScoreListType;
    cname: string;
    hname: string;
}

export interface NormalScoreListType {
    hfirstLabel: string;
    cfirstLabel: string;
    hfullLabel: string;
    cfullLabel: string;
}

export interface resultDetailType {
    id: string;
    league: string;
    leagueId: number;
    gid: string;
    matchStartTime: string;
    type: number;
    typeLabel: string;
    normalScore: resultDetailScore;
    cornerKickScore: resultDetailScore;
    redScore: resultDetailScore;
    yellowScore: resultDetailScore;
    normalDetail: resultDetailItemType;
    cornerKickDetail: resultDetailItemType;
    cardDetail: resultDetailItemType;
    basketballDetail: BasketballDetail;
    hname: string;
    cname: string;
}

export interface BasketballDetail {
    id: string;
    gid: string;
    hfullLabel: string;
    cfullLabel: string;
    cnode4Label: string;
    hnode1Label: string;
    hnode2Label: string;
    hnode3Label: string;
    hnode4Label: string;
    cnode1Label: string;
    cnode2Label: string;
    cnode3Label: string;
    hfirstHalfLabel: string;
    cfirstHalfLabel: string;
    hsecondHalfLabel: string;
    csecondHalfLabel: string;
    hovertimeLabel: string;
    covertimeLabel: string;
}

export interface resultDetailItemType {
    id: string;
    gid: string;
    bhLabelCode: number;
    bhLabel: string;
    rgList: string[];
    f2gLabel: string;
    f3gLabel: string;
    fgLabel: string;
    fgLabelCode: number;
    paLabelCode: number;
    paLabel: string;
    rcdLabelCode: number;
    rcdLabel: string;
    pgfLabelCode: number;
    pgfLabel: string;
    pglLabelCode: number;
    pglLabel: string;
    t1gLabelCode: number;
    t1gLabel: string;
    t3gLabelCode: number;
    t3gLabel: string;
    hagmLabel: string;
    hbgmLabel: string;
    hcgmLabel: string;
    hdgmLabel: string;
    hegmLabel: string;
    hfgmLabel: string;
    cagmLabel: string;
    cbgmLabel: string;
    ccgmLabel: string;
    cdgmLabel: string;
    cegmLabel: string;
    cfgmLabel: string;
}

export interface resultDetailScore {
    hfirstLabel: string;
    cfirstLabel: string;
    hfullLabel: string;
    cfullLabel: string;
}

export interface HallListType {
    sportType: number;
    sportTypeName: string;
    show?: boolean;
    leagueList: LeagueListType[];
}

export interface LeagueListType {
    leagueName: string;
    matchCount: number;
    sportType: number;
    sportTypeName: string;
    show?: boolean;
    sportList: SportListType[];
}

export interface SportListType {
    gid: string;
    hid: number;
    cid: number;
    hName: string;
    cName: string;
    hIcon: string;
    cIcon: string;
    matchStartTime: string;
    playCount: number;
    timer: number;
    now_score: string;
    half_score: string;
    isHalf: number;
    playList: PlayListType[];
    leagueName?: string;
    leagueCode?: number;
    nowCornerScore?: string;
    nowRedScore?: string;
    nowYellowScore?: string;
    categoryCode: number;
    basketProgressText?: string;
    nowOvertimeScore: string;
    status?: number;
}

export interface PlayListType {
    gid: number;
    playCode: number;
    playName: string;
    oddsList: OddsListType[];
    betPlayTitle: string;
    betPlayType?: string;
    matchType: number;
    is_include_principal: number;
    show?: boolean;
    oddsGroupByList?: OddsListType[][];
    gridStyle?: string;
}

export interface OddsListType {
    playItemCode: number;
    result: string;
    itemId: string;
    odds: string;
    status: number;
    oldStatus: number;
    showTitle: string;
    betShowTitle: string;
    // 对比之前的赔率是大还是小
    compare?: number; // 0: 相等 1: 大 2: 小
    gridType?: number | null;
    is_include_principal?: number; // 欧洲盘赔率不变 ,香港盘时 is_include_principal为true 则表示包含本金,odds需要-1.否则不需要-1
    oddsE?: string;
}

export interface BettingListTYpe {
    playItemCode: number;
    result: string;
    itemId: string;
    odds: string;
    status: number;
    showTitle: string;
    leagueName: string;
    categoryCode: number;
    hName: string;
    cName: string;
    gid: string;
    hid: number;
    cid: number;
    playCode: number;
    playName: string;
    sportType: number;
    sportTypeName: string;
    money: string;
    showInput?: boolean;
    betPlayTitle: string;
    betShowTitle: string;
    matchType: number;
    now_score: string;
    is_include_principal: number;
    compare?: number;
    playItemName?: string;
    timer?: number;
    isHalf?: number;
    canWinMoney?: number;
    orderStatus?: number;
    billNo?: number | string;
}

export interface BettingOutrightListType {
    playItemCode: number;
    itemId: string | number;
    odds: string;
    status: number;
    leagueName: string;
    playItemName: string;
    categoryCode: number;
    gid: string | number;
    sportType: number;
    playCode: number;
    playName: string;
    money: string;
    showInput?: boolean;
    compare?: number;
    is_include_principal: number;
}

export interface betItemsType {
    matchType: number;
    gid: string;
    categoryCode: number;
    playCode: number;
    playItemCode: number;
    itemId: string;
    odds: string;
    sportType: number;
    canWinMoney?: number | string;
    betMoney?: string | undefined;
    money?: string | undefined;
    is_include_principal: number;
}

export interface betModeItemsType {
    matchType: number;
    gid: string;
    categoryCode: number;
    playCode: number;
    playItemCode: number;
    itemId: string;
    odds: string;
    sportType: number;
    is_include_principal: number;
}

export interface OutrightCollectListType {
    id: number;
    name: string;
    platformSort: number;
    count: number;
}

export interface HotSportListType {
    gid: string;
    hid: number;
    cid: number;
    hName: string;
    cName: string;
    hIcon: string;
    cIcon: string;
    matchStartTime: string;
    playCount: number;
    leagueName?: string;
    playList: HotPlayListType;
    categoryCode: number;
    sportType: number;
}

export interface HotPlayListType {
    playCode: number;
    playName: string;
    oddsList: OddsListType[];
    matchType: number;
    is_include_principal: number;
}

export interface OutrightPlayListType {
    playCode: number;
    playName: string;
    categoryCode: number;
    playCount: number;
    oddsList: OutrightOddsListType[];
    show?: boolean;
    showMore?: boolean;
}

export interface OutrightOddsListType {
    itemId: string;
    playItemCode: number;
    odds: string;
    oldStatus: number;
    status: number;
    playItemName: string;
    compare: number;
}

export interface IRecordList {
    account: number;
    betMatchNumber: number;
    betMode: number;
    betModeLabel: string;
    billNo: string;
    billTime: string;
    canWinMoney: number;
    cusAccount: number;
    detailList: IDetailList[];
    duplexNumber: number;
    id: string;
    inAdvanceSettleMoney: number;
    isCanInAdvanceSettle: boolean;
    isChecked: boolean;
    isInAdvanceSettle: boolean;
    settleStatus: number;
    settleStatusLabel: string;
    settleTime: string;
    sportType: number;
    sportTypeLabel: string;
    status: number;
    statusLabel: string;
    validAccount: number;
    step: number;
    newSettleMoney?: number;
    hasSettle?: boolean;
}

export interface IDetailList {
    billNo: string;
    categoryCode: number;
    categoryCodeLabel: string;
    cname: string;
    content: string;
    covertimeResult: number;
    cfirstResult: number;
    cfullResult: number;
    cinterruptResult: number;
    fixtureStatus: number;
    fixtureStatusLabel: string;
    gid: string;
    handicap: string;
    hfirstResult: number;
    hfullResult: number;
    hinterruptResult: number;
    hname: string;
    hovertimeResult: number;
    id: string;
    interruptHalf: number;
    inProgressHalf: number;
    isChecked: boolean;
    isRunningBall: boolean;
    league: string;
    matchNowScore: string;
    matchStartTime: string;
    matchType: number;
    matchTypeLabel: string;
    nowMatchRunTime: string;
    nowScore: string;
    odds: number;
    playCode: number;
    playItemCode: string;
    playName: string;
    ratio: string;
    settleResult: number;
    settleResultLabel: string;
    settleStatus: number;
    sportHalf: number;
    sportHalfLabel: string;
    sportType: number;
    sportTypeLabel: string;
    strong: string;
    timer: number;
    basketballShowDetail?: boolean;
    hIcon?: string;
    cIcon?: string;
}

export interface ISubtotal {
    account: number;
    cusAccount: number;
    payoutMoney: number;
    validAccount: number;
}

export interface ShowBettingListType {
    sportType: number;
    autoAcceptOddsType: WsSportOdds;
    betMode: number;
    handicap: string;
    canWinMoney?: number;
    betMoney?: string | undefined;
    orderStatus?: number;
    billNo?: number | string;
    betItems: BettingListTYpe[];
}

export interface sportConfigType {
    pageType: number;
    oddsPreferenceType: WsSportOdds;
    footballPushType: string;
    pushSoundType: number;
    handicap: string;
}
